import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import BackToTop from '../components/layout/BackToTop';
import LaunchUpdatesSection from '../components/sections/LaunchUpdatesSection';
import { usePageMeta } from '../lib/usePageMeta';

export default function UpdatesPage() {
  usePageMeta(
    'Launch Updates — ResiAX',
    'Not ready for the pilot yet? Get ResiAX launch updates by email, or share your housing experience through our short research survey.'
  );

  React.useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFAF8]">
      <Header />
      <main className="pt-20" data-testid="updates-page">
        <LaunchUpdatesSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
